import {
  DatePicker as BaseDatePicker,
  DatepickerProps,
} from "baseui/datepicker";

// baseui's own calendar header falls back to a hardcoded MIN_YEAR/MAX_YEAR
// (2000-2030) for its year dropdown and month navigation whenever no
// maxDate is supplied, so callers silently lose the ability to pick years
// past 2030 unless we give it one.
const DEFAULT_MAX_DATE = new Date(2099, 11, 31);

const DatePicker: React.FC<DatepickerProps> = ({
  overrides,
  maxDate,
  ...props
}) => {
  const { Input: inputOverride, ...restOverrides } = overrides ?? {};
  const callerInputStyle =
    inputOverride && typeof inputOverride.style === "object"
      ? inputOverride.style
      : {};

  return (
    <BaseDatePicker
      {...props}
      maxDate={maxDate ?? DEFAULT_MAX_DATE}
      formatString="MM/dd/yyyy"
      overrides={{
        Input: {
          ...inputOverride,
          style: {
            cursor: "pointer",
            backgroundColor: "#f9fafb",
            color: "#111827",
            border: "1px solid #E5E7EB",
            borderRadius: "6px",
            transition: "border-color 0.2s",
            ":hover": {
              backgroundColor: "#f3f4f6",
              borderColor: "#A1A1AA",
            },
            ":focus": {
              outline: "none",
              boxShadow: "none",
              backgroundColor: "#f3f4f6",
              borderColor: "#2563EB",
            },
            // Caller overrides merge last so per-usage tweaks (e.g. width)
            // don't wipe the shared styling above.
            ...callerInputStyle,
          },
        },
        ...restOverrides,
      }}
    />
  );
};

export default DatePicker;
